import * as React from 'react';
import { AppUser } from 'Src/views/App/App';
import { SchoolEvent } from 'Src/models/event';
import { EventReadOnlyHero } from 'Src/components/EventReadOnlyHero/EventReadOnlyHero';

interface Props {
  user: AppUser;
  event: SchoolEvent;
  eventName: string;
  activeSchoolId?: string;
  isPrevButtonDisabled?: boolean;
  isNextButtonDisabled?: boolean;
  onPrevEventClick?: () => void;
  onNextEventClick?: () => void;
  onReportAvailabilityClick?: () => void;
  onViewMapClick?: () => void;
}

export function ChildrenEventMainInformation(props: Props) {
  return <EventReadOnlyHero {...props} />;
}
